class AudioPlayer {

    constructor(el, options) {
      this.options = options;
      this.audioElement = el;
      this.container = el.closest('.m-audioplayer');
      this.audioCtx = this.audioContextCheck();

      if (!this.audioCtx) {
          return;
      }

      if (this.track === undefined) {
        this.track = this.audioCtx.createMediaElementSource(this.audioElement);
      }

      this.audioElements = document.querySelectorAll('audio');

      this.container = this.audioElement.closest(options.classes.container);
      this.playButton = this.container.querySelector(options.classes.player);
      this.timer = this.container.querySelector(options.classes.timeCurrent);
      this.timerTotal = this.container.querySelector(options.classes.timeTotal);
      this.timerWrapper = this.container.querySelector(options.classes.timeProgress);

      this.connectTrack();
      this.attachListeners();

      this.audioElement.classList.remove('unprocessed');
    }

    audioContextCheck() {
        if (typeof AudioContext !== "undefined") {
            return new AudioContext();
        } else if (typeof webkitAudioContext !== "undefined") {
            return new webkitAudioContext();
        } else if (typeof mozAudioContext !== "undefined") {
            return new mozAudioContext();
        } else {
            this.container.classList.add('nonejs');
            this.audioElement.setAttribute('controls', '');

            return false;
        }
    }

    attachListeners() {
      const self = this;

      this.timerWrapper.addEventListener('input', this.onScrub.bind(this, self));
      this.audioElement.addEventListener('timeupdate', this.onTimeUpdate.bind(this, self));
      this.audioElement.addEventListener('ended', this.onEnd.bind(this, self));
      this.playButton.addEventListener('click', this.onPlayButtonClick.bind(this, self));
      this.audioElement.addEventListener('loadedmetadata', this.setTotalTime.bind(this, self));
    }

    getContext() {
      let ac = null;
      if ( !window.AudioContext && !window.webkitAudioContext ) {
        console.warn('Web Audio API not supported in this browser');
      } else {
        ac = new ( window.AudioContext || window.webkitAudioContext )();
      }
      return ac;
    }

    connectTrack() {
      this.track.connect(this.audioCtx.destination);
    }

    formatTime(timeInSeconds) {
      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = Math.floor(timeInSeconds - minutes * 60);

      const minuteValue = ('00' + minutes).slice(-2);
      const secondValue = ('00' + seconds).slice(-2);

      return `${minuteValue}:${secondValue}`;
    }

    setTotalTime(self) {
      if(!isNaN(parseFloat(self.audioElement.duration))) {
        self.timerTotal.innerHTML = this.formatTime(self.audioElement.duration);
      }
    }

    setCurrentTime() {
      this.timer.textContent = this.formatTime(this.audioElement.currentTime);
    }

    onTimeUpdate(self) {
      self.setCurrentTime();

      const timerPos = (100 * (self.audioElement.currentTime / self.audioElement.duration));
      const timerPosVal = timerPos.toFixed(2);

      self.timerWrapper.value = timerPosVal;
      self.updateScrubber(self.timerWrapper, timerPosVal);
    }

    onPlayButtonClick(self) {
      if (self.audioCtx.state === 'suspended') {
        self.audioCtx.resume();
      }

      self.togglePlay(self.audioElement, self);

      const state = self.audioElement.getAttribute('aria-checked');
      self.audioElement.setAttribute('aria-checked', state === 'true' ? 'false' : 'true' );
    }

    onEnd(self) {
      self.playButton.dataset.playing = 'false';
      self.playButton.setAttribute('aria-checked', 'false');
    }

    onScrub(self, e) {
      const timePos = (self.audioElement.duration * (e.target.value / 100));

      self.audioElement.currentTime = timePos;
      self.updateScrubber(e.target, e.target.value);
    }

    updateScrubber(scrubberElement, value) {
      const colorStop = (value/100);
      scrubberElement.style.backgroundImage = `
        -webkit-gradient(linear, left top, right top,
        color-stop(${colorStop}, #FFFFFF),
        color-stop(${colorStop}, transparent)
        )
      `;
    }

    stop(audio, playButton) {
      audio.pause();
      playButton.dataset.playing = 'false';
      playButton.setAttribute('aria-checked', 'false');
    }

    play(audio, playButton) {
      audio.play();
      playButton.dataset.playing = 'true';
      playButton.setAttribute('aria-checked', 'true');
    }

    togglePlay(audio, self) {
      if (audio.paused) {
        self.stopAllAudio();
        self.play(audio, self.playButton);
      } else {
        self.stop(audio, self.playButton);
      }
    }

    stopAllAudio() {
      this.audioElements.forEach(_audioElement => {
        const _audioElementContainer = _audioElement.closest(this.options.classes.container);
        const _playButton = _audioElementContainer.querySelector(this.options.classes.player);

        this.stop(_audioElement, _playButton);
      });
    }

  }

  export { AudioPlayer };
